import styles from "./ClientListAddress.module.css";
import dangerImage from "../../assets/dangerImage.png";

import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom"; // Importar o componente Link
import ClientAddress from "../ClientAddress";
import api from "../../utils/axios/api";

export interface ClientAddressType {
    id: string;
    name?: string;
    state: string;
    city: string;
    street: string;
    district: string;
    complement?: string;
    zipCode: string;
    number: string;
}

const ClientListAddress = () => {
    const {t} = useTranslation();

    const [addresses, setAddresses] = useState<ClientAddressType[]>([]);

    const clientId = localStorage.getItem('clientId');

    useEffect(() => {
        const fetchAddresses = async () => {
            try {
                const apiClientInfo = await api.get(`/address/client/${clientId}`);
                const apiAddresses = apiClientInfo.data.map((info: any) => info.address);
                console.log(apiAddresses)
                setAddresses(apiAddresses);
            } catch (e) {
                console.error("Error fetching addresses:", e);
            }
        };

        fetchAddresses();
    }, []);

    const handleRemoveAddress = (addressId: string) => {
        setAddresses((prev) => {
            const newAddresses = prev.filter((item) => item.id !== addressId);
            return newAddresses;
        });
    };

    return (
        <div className={styles.main_container}>
            <h1>{t(`accountMenu.addresses`)}</h1>
            {addresses.length > 0 && (
                <ul className={styles.addressesList}>
                    {addresses.map((address) => (
                        <li key={address.id}>
                            <ClientAddress
                                addressInfo={address}
                                handleRemove={(id) => handleRemoveAddress(id)}
                            />
                        </li>
                    ))}
                </ul>
            )}
            {addresses.length <= 0 && (
                <div className={styles.noAddressesContainer}>
                    <div
                        className={styles.iconNoAddresses}
                        style={{
                            backgroundImage: `url(${dangerImage})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            width: "7rem",
                            height: "7rem",
                        }}
                    ></div>
                    <h3>{t(`accountMenu.noAddresses`)}</h3>
                </div>
            )}
            <div className={styles.buttonContainer}>
                <Link to="/auth/client/account/addresses/add" className={styles.addAddressButton}>
                    {t(`accountMenu.addNewAddress`)}
                </Link>
            </div>
        </div>
    );
};

export default ClientListAddress;
